import footerTemplate from './footer.html';

class Footer {
    constructor() {
        this.template = footerTemplate;
        this.restrict = 'E';
    }

    /**
     * Factory
     * @return {Object}
     */
    static directiveFactory() {
        Footer.instance = new Footer();
        return Footer.instance;
    }
}

export default Footer;



/** WEBPACK FOOTER **
 ** ./src/app/directives/footer/footer.js
 **/